<template>
  <DefaultLayout>
    <div slot="content">
      <div class="d-flex align-center py-3">
        <div class="title">Email Automations</div>
        <v-spacer></v-spacer>
        <v-dialog v-model="createDialog" width="500">
          <template v-slot:activator="{ on, attrs }">
            <v-btn depressed color="primary" v-bind="attrs" v-on="on">
              Create Email Automation
            </v-btn>
          </template>

          <v-card>
            <v-card-title>
              Create Email Automation
              <v-spacer></v-spacer>
              <v-btn @click="createDialog = false" icon>
                <v-icon>close</v-icon>
              </v-btn>
            </v-card-title>

            <v-card-text v-if="createDialogDataLoading">
              <v-row justify="center">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
              </v-row>
            </v-card-text>

            <v-card-text v-else>
              <v-form ref="createEmailAutomationsForm">
                <v-text-field
                  v-model="newEmail"
                  class="mr-1"
                  label="Automation Email"
                  type="text"
                  :rules="[validateRequiredRule, validateEmailRule]"
                >
                </v-text-field>
                <v-select
                  :items="organizations"
                  item-text="name"
                  item-value="id"
                  v-model="selectedOrganization"
                  label="Organizations"
                >
                </v-select>
                <v-select
                  v-if="accountDetails"
                  :items="accountDetails.account.accounts"
                  item-text="name"
                  item-value="accountId"
                  v-model="selectedAccount"
                  label="Accounts"
                >
                </v-select>
                <v-select
                  v-if="templates && accountFlag"
                  :items="selectedAccountDetails.users"
                  item-value="userId"
                  v-model="selectedRequester"
                  label="Requesters"
                >
                  <template #item="{ item }"> {{ item.firstName }} {{ item.lastName }} </template>
                  <template #selection="{ item }">
                    {{ item.firstName }} {{ item.lastName }}
                  </template>
                </v-select>
                <v-select
                  v-if="templates && accountFlag"
                  :items="templates"
                  item-text="name"
                  item-value="id"
                  v-model="selectedTemplate"
                  label="Templates"
                >
                </v-select>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn tile text color="blue" @click="createDialog = false">Close</v-btn>
              <v-btn
                id="new-profile-template-save"
                tile
                dark
                depressed
                color="blue"
                @click="onSubmitCreateEmailAutomation"
                >Save</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
      <div v-if="emailAutomationsData">
        <v-data-table
          v-if="emailAutomationsData"
          :headers="headers"
          :loading="dataLoading"
          :items="emailAutomationsData"
          v-model="selected"
          show-select
          :footer-props="{
            itemsPerPageOptions: [10, 20, 50, { text: 'All', value: -1 }],
            showFirstLastPage: false,
            prevIcon: 'fal fa-chevron-left',
            nextIcon: 'fal fa-chevron-right',
            itemsPerPageText: 'Automation email per page'
          }"
          :hide-default-footer="emailAutomationsData && emailAutomationsData.length < 11"
        >
          <template #top="{ pagination, options, updateOptions }">
            <v-data-footer
              :pagination="pagination"
              :options="options"
              :itemsPerPageOptions="[10, 20, 50, { text: 'All', value: -1 }]"
              :showFirstLastPage="false"
              prevIcon="fal fa-chevron-left"
              nextIcon="fal fa-chevron-right"
              @update:options="updateOptions"
              items-per-page-text="Automation email per page"
            />
          </template>
          <template #item.organizationName="{ item }">
            <div style="height: 100%; padding: 13px 5px 10px 15px">
              <span>{{ item.organizationName }}</span>
            </div>
          </template>
          <template #item.accountName="{ item }">
            <div style="height: 100%; padding: 13px 5px 10px 15px">
              <span>{{ item.accountName }}</span>
            </div>
          </template>

          <template #item.requesterName="{ item }">
            <div style="height: 100%; padding: 13px 5px 10px 15px">
              <span>{{ item.requesterName }}</span>
            </div>
          </template>
          <template #item.templateName="{ item }">
            <div style="height: 100%; padding: 13px 5px 10px 15px">
              <span>{{ item.templateName }}</span>
            </div>
          </template>
          <template #item.automationEmail="{ item }">
            <div style="height: 100%; padding: 13px 5px 10px 15px">
              <span>{{ item.automationEmail }}</span>
            </div>
          </template>
          <template #item.enabled="{ item }">
            <div style="height: 100%; padding: 13px 5px 10px 15px">
              <v-icon v-if="item.enabled" color="green">fas fa-check</v-icon>
              <v-icon v-else color="red">fas fa-times</v-icon>
            </div>
          </template>
          <template #item.id="{ item }">
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-btn
                  v-on="on"
                  :disabled="item.deletion"
                  text
                  icon
                  color="blue"
                  @click="requestUpdateEmailAutomation(item.id)"
                  ><v-icon>mdi mdi-update</v-icon></v-btn
                >
              </template>
              <span>Update Email Automation</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-btn v-on="on" text icon color="red" @click="requestDeleteEmailAutomation(item.id)"
                  ><v-icon>mdi mdi-delete-outline</v-icon></v-btn
                >
              </template>
              <span>Delete EmailA utomation</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </div>
    </div>
  </DefaultLayout>
</template>

<script>
import DefaultLayout from '@/layouts/DefaultLayout';
import { mapState, mapGetters } from 'vuex';
import { GET_EMAIL_AUTOMATIONS } from '@/store/getters.type';
import {
  REQUEST_EMAIL_AUTOMATIONS,
  GET_ORGANIZATIONS,
  GET_ACCOUNT_DETAILS,
  GET_TEMPLATES,
  CREATE_EMAIL_AUTOMATION,
  UPDATE_EMAIL_AUTOMATION,
  DELETE_EMAIL_AUTOMATION
} from '@/store/actions.type';

export default {
  name: '',
  components: {
    DefaultLayout
  },
  data() {
    return {
      createDialog: false,
      validateRequiredRule: (v) => !!v || 'This field is required',
      validateEmailRule: (v) => {
        // eslint-disable-next-line
        const re =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return !v || re.test(String(v).toLowerCase()) || 'Please enter valid Email';
      },
      newEmail: '',
      selectedOrganization: null,
      accountDetails: null,
      accountFlag: false,
      selectedAccount: null,
      selectedAccountDetails: null,
      selectedRequester: null,
      selectedTemplate: null,
      emailAutomationId: null,
      dataLoading: false,
      createDialogDataLoading: false,
      organizations: null,
      headers: [
        { text: 'Organization', value: 'organizationName', align: 'left' },
        { text: 'Account', value: 'accountName', align: 'left' },
        { text: 'Requester', value: 'requesterName', align: 'left' },
        { text: 'Template', value: 'templateName', align: 'left' },
        { text: 'Automation Email', value: 'automationEmail', align: 'left' },
        { text: 'Enabled', value: 'enabled', align: 'left' },
        { text: 'Actions', value: 'id', align: 'left' }
      ],
      selected: []
    };
  },

  computed: {
    ...mapState({
      templates: (state) => state.profileTemplates.selectedAccountTemplates
    }),
    ...mapGetters({ emailAutomationsData: GET_EMAIL_AUTOMATIONS })
  },
  methods: {
    async getEmailAutomations() {
      this.dataLoading = true;
      try {
        await this.$store.dispatch(REQUEST_EMAIL_AUTOMATIONS);
        this.dataLoading = false;
      } catch (err) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Error getting organizations. Please contact support@planetverify.com'
        });
        this.dataLoading = false;
      }
    },
    async getOrganizations() {
      try {
        const response = await this.$store.dispatch(GET_ORGANIZATIONS);
        this.organizations = response.sort((a, b) => a.name.localeCompare(b.name));
      } catch (err) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Error getting organizations. Please contact support@planetverify.com'
        });
      }
    },
    async getAccountDetails(accountId) {
      try {
        this.accountDetails = await this.$store.dispatch(GET_ACCOUNT_DETAILS, accountId);
      } catch (err) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Error getting account details. Please contactsupport@planetverify.com'
        });
      }
    },
    async getTemplates(accountId) {
      try {
        await this.$store.dispatch(GET_TEMPLATES, accountId);
      } catch (err) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Error getting templates. Please contact support@planetverify.com'
        });
      }
    },
    async onSubmitCreateEmailAutomation() {
      if (this.$refs.createEmailAutomationsForm.validate()) {
        const data = {
          automationEmail: this.newEmail,
          organizationId: this.selectedOrganization,
          accountId: this.selectedAccount,
          templateId: this.selectedTemplate,
          requesterId: this.selectedRequester
        };

        if (
          !data.automationEmail ||
          !data.organizationId ||
          !data.accountId ||
          !data.templateId ||
          !data.requesterId
        ) {
          this.$notify({
            type: 'error',
            title: 'Missing Data',
            text: 'Please ensure all fields are filled before submitting.'
          });
          return;
        }

        try {
          this.createDialogDataLoading = true;
          await this.$store.dispatch(CREATE_EMAIL_AUTOMATION, data);
          setTimeout(() => {
            this.getEmailAutomations();
            this.$notify({
              type: 'success',
              title: 'Success',
              text: 'Email automation created successfully'
            });
            this.newEmail = '';
            this.selectedOrganization = null;
            this.selectedAccount = null;
            this.selectedTemplate = null;
            this.accountFlag = false;
            this.createDialogDataLoading = false;
            this.createDialog = false;
          }, 1000);
        } catch (err) {
          this.$notify({
            type: 'error',
            title: 'Error',
            text: 'Error creating email automation. Please contact support@planetverify.com'
          });
        }
      }
    },

    async updateEmailAutomation(itemId) {
      try {
        const data = {
          id: itemId,
          enabled: !this.emailAutomationsData.find((item) => item.id === itemId).enabled
        };
        await this.$store.dispatch(UPDATE_EMAIL_AUTOMATION, data);
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Email automation updated successfully'
        });
        setTimeout(() => {
          this.getEmailAutomations();
        }, 1000);
      } catch (err) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Error updating email automation. Please contact support@planetverify.com'
        });
      }
    },
    requestUpdateEmailAutomation(itemId) {
      const isConfirmed = confirm('Are you sure? You are about to update this email automation');

      if (isConfirmed) {
        this.updateEmailAutomation(itemId);
      }
    },
    async deleteEmailAutomation(itemId) {
      try {
        await this.$store.dispatch(DELETE_EMAIL_AUTOMATION, itemId);
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Email automation deleted successfully'
        });
        setTimeout(() => {
          this.getEmailAutomations();
        }, 1000);
      } catch (err) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Error deleting email automation. Please contact support@planetverify.com'
        });
      }
    },
    requestDeleteEmailAutomation(itemId) {
      const isConfirmed = confirm('Are you sure? You are about to delete this email automation');

      if (isConfirmed) {
        this.deleteEmailAutomation(itemId);
      }
    }
  },

  watch: {
    selectedOrganization: {
      handler: function (val) {
        if (val) {
          this.getAccountDetails(val);
        }
      },
      deep: true
    },
    selectedAccount: {
      handler: function (val) {
        if (val) {
          this.getTemplates(val);
          this.accountFlag = true;
          this.selectedAccountDetails = this.accountDetails.account.accounts.find(
            (item) => item.accountId === this.selectedAccount
          );
        }
      },
      deep: true
    }
  },
  mounted() {
    this.getEmailAutomations();
    this.getOrganizations();
  }
};
</script>
